import React from "react";
import { Button } from "@mui/material";

export const ManageTableButton = (props: ManageTableButtonProps) => {
  const { text = "Manage table", onClick } = props;
  return (
    <button className="module-manage-table-button" onClick={onClick}>
      <Button component='div' color='secondary'>{text}</Button>
    </button>
  );
};

interface ManageTableButtonProps {
  text?: string;
  onClick?: () => void;
}
